jQuery(document).ready(function ($) {

  // Fill Headlines
  if($('.module-toc')){
    $content_arr = [];
    $('[data-toc-headline]').each(function(){
      if($(this).attr('id')){ 
        $content_arr.push({
          id : $(this).attr('id'),
          content : $(this).attr('data-toc-headline')
        });
      }
    });
    
    $($content_arr).each(function(){
      $('.toc-list').append("<li><a href='#"+ this['id'] +"'>"+ this['content'] +"</a></li>");
    });

  }

  // Scroll Links
  $('.module-toc .toc-content ul li a').click(function (event){
    event.preventDefault();
    tocScrollTo($(this));
    tocTogglePos();
  });

  // Open & Close
  $('.module-toc .toc-trigger').click(function (event){
    tocTogglePos();
  });


  // Automatisch schließen, wenn gescrollt wird
  $( window ).scroll(function() {
    if($('.module-toc').hasClass('is-open')){
      tocTogglePos();
    }
  });

  var tocLinkScroll = function (){
    tocScrollTo($(this));
  };

  var tocTogglePos = function () {
    $('.module-toc').toggleClass('is-open');
  };

  var tocScrollTo = function (target) {
    var t = $(target).attr('href');
    var $page = $('html, body');

    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
      $page.stop();
    });

    $page.animate({
      scrollTop: $('' + t + '').offset().top,
    }, 1000, function () {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });

    return false; 
  };

});